module.exports = __webpack_public_path__ + "img/icon_star_outline.c0433294.svg";